import React, { useState, useEffect, CSSProperties } from 'react';
import cx from 'clsx';

interface IStrokeLineProps {
    active: boolean;
    inverseAnimation?: boolean;
    fill?: boolean;
    className?: string;
    style?: CSSProperties;
}

export const StrokeLine: React.FC<IStrokeLineProps> = React.memo((props: IStrokeLineProps): JSX.Element => {
    const [lineCollapsed, setLineCollapsed] = useState(!!props.inverseAnimation);
    const [activeStateQueue, setActiveStateQueue] = useState<boolean[]>([]);
    const [transitionActive, setTransitionActive] = useState(false);

    const updateWithLatestState = () => {
        let latest = activeStateQueue.slice(-1)[0] || false;
        // Hover mode works the inverted way of regular mode
        if (props.inverseAnimation) {
            latest = !latest;
        }
        if (!transitionActive && lineCollapsed !== latest) {
            setLineCollapsed(latest);
            setTransitionActive(true);
        }
    };

    useEffect(() => {
        setActiveStateQueue([...activeStateQueue.slice(-1), props.active]);
    }, [props.active]);

    useEffect(() => {
        updateWithLatestState();
    }, [activeStateQueue]);


    useEffect(() => {
        updateWithLatestState();
    }, [transitionActive]);

    const onStrokeAnimationEnd = (): void => {
        setTransitionActive(false);
        const latest = activeStateQueue.slice(-1);
        if (latest[0] && !props.inverseAnimation) {
            setActiveStateQueue([...latest, false]);
        } else {
            setActiveStateQueue([...latest]);
        }
    };

    return (
        <span
            className={cx(props.className, 'stroke-line', { 'stroke-line--active': lineCollapsed, 'stroke-line--fill': props.fill })}
            onTransitionEnd={(): void => onStrokeAnimationEnd()}
            style={props.style}
        />
    );
});
